module.exports = __webpack_public_path__ + "img/done.2a25a789.svg";